import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';

import { AuthStore } from '../storage/auth';

const AUTH_SKEY_HEADER = 'x-boemm-skey';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = inject(AuthStore).getToken();
  if (!token) return next(req);

  return next(
    req.clone({
      headers: req.headers.set(AUTH_SKEY_HEADER, token),
      withCredentials: true,
    })
  );
};
